import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkSession, logout } from '../redux/slices/authSlice';

const useSessionMonitor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, expiresAt } = useSelector((state) => state.auth);
  const [showExtender, setShowExtender] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setShowExtender(false);
      return;
    }

    // Check session every 30 seconds
    const sessionCheckInterval = setInterval(() => {
      const now = new Date().getTime();
      const timeRemaining = expiresAt - now;

      // Show warning popup 1 minute before expiration
      if (timeRemaining > 0 && timeRemaining <= 60 * 1000) {
        setShowExtender(true);
      }

      // If session expired, logout and redirect
      if (timeRemaining <= 0) {
        dispatch(checkSession());
        setShowExtender(false);
        dispatch(logout());
        navigate('/');
      }
    }, 30000); // Check every 30 seconds

    // Also check immediately
    const now = new Date().getTime();
    const timeRemaining = expiresAt - now;
    
    if (timeRemaining > 0 && timeRemaining <= 60 * 1000) {
      setShowExtender(true);
    } else if (timeRemaining <= 0) {
      dispatch(checkSession());
      setShowExtender(false);
      dispatch(logout());
      navigate('/');
    }

    return () => {
      clearInterval(sessionCheckInterval);
    };
  }, [isAuthenticated, expiresAt, dispatch, navigate]);

  const handleExtendSession = () => {
    setShowExtender(false);
  };

  const handleLogout = () => {
    setShowExtender(false);
  };

  return {
    showExtender,
    handleExtendSession,
    handleLogout,
  };
};

export default useSessionMonitor;
